/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/

// @mui material components
import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'
import Icon from '@mui/material/Icon'

// MD UI Dashboard PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// MD UI Dashboard PRO React example components
import DataTable from 'examples/Tables/DataTable'
import AppData from './components/data'
import TeamTagCreateModal from './components/Modals/TeamModal'
import { useEffect } from 'react'
import Loader from 'examples/Loader'

function Default() {
  const { loader, teamTagsTable, handleRefresh } = AppData()

  const onLoad = () => { }

  useEffect(onLoad, [])
  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <>
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <MDBox px={3}>
                  <MDBox sx={{ textAlign: 'right' }}>
                    <TeamTagCreateModal
                      handleRefresh={handleRefresh}
                    />
                  </MDBox>
                  <DataTable table={teamTagsTable} canSearch entriesPerPage={5} />
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
        </>
      )}
    </>
  )
}

export default Default
